import React from "react";
import { ButtonSpinnerProps } from "./ButtonSpinner.types";
import { Box } from "../../../primitives/Box/Box";
import { Flex } from "../../../primitives/Flex/Flex";

export const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({
  size = "0.7rem",
  color,
  dataCy,
}) => {
  const dotColor = color || "background.danger.secondary";

  const dotStyle = {
    width: size,
    height: size,
    margin: "0 6px",
    borderRadius: "50%",
    backgroundColor: dotColor,
    opacity: 1,
    animation: "bouncing-loader 0.6s infinite alternate",
  };

  return (
    <>
      <style>{`
        @keyframes bouncing-loader {
          to {
            opacity: 0.1;
            transform: translateY(-16px);
          }
        }
        .spinner-dot-1 { animation-delay: 0s; }
        .spinner-dot-2 { animation-delay: 0.2s; }
        .spinner-dot-3 { animation-delay: 0.4s; }
      `}</style>
      <Flex
        justifyContent="center"
        alignItems="center"
        py="0.25rem"
        px="0.5rem"
        data-cy={dataCy}
      >
        <Box style={dotStyle} className="spinner-dot-1" />
        <Box style={dotStyle} className="spinner-dot-2" />
        <Box style={dotStyle} className="spinner-dot-3" />
      </Flex>
    </>
  );
};
